export const SET_AUTHORIZATION = 'SET_AUTHORIZATION';
export const SET_QUANTITY_PRODUCT_PANTRY = 'SET_QUANTITY_PRODUCT_PANTRY';
export const REMOVE_PRODUCT_PANTRY = 'REMOVE_PRODUCT_PANTRY';
export const ADD_PRODUCT_PANTRY = 'ADD_PRODUCT_PANTRY';
export const UPDATE_PRODUCT_PANTRY = 'UPDATE_PRODUCT_PANTRY';
export const ADD_TO_SHOPPING_LIST = 'ADD_TO_SHOPPING_LIST';
export const UPDATE_PANTRY_WITH_SHOPPING_LIST = 'UPDATE_PANTRY_WITH_SHOPPING_LIST';
export const SET_SELECTED_PRODUCTS = 'SET_SELECTED_PRODUCTS';
export const CLEAR_SHOPPING_LIST = 'CLEAR_SHOPPING_LIST';
export const REMOVE_FROM_SHOPPING_LIST = 'REMOVE_FROM_SHOPPING_LIST';
export const UPDATE_QUANTITY_ON_LIST = 'UPDATE_QUANTITY_ON_LIST';
export const INITIAL_STATE = 'INITIAL_STATE';
